const runtimeConfig = typeof window !== "undefined" && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : {};

const isLocalEnvironment = () => {
  if (typeof window === "undefined") {
    return process.env.NODE_ENV !== "production";
  }
  return /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname);
};

const buildLocalUrl = (port, path = "") => {
  const protocol = typeof window !== "undefined" && window.location.protocol ? window.location.protocol : "http:";
  const base = `${protocol}//localhost:${port}`;
  return path ? `${base}${path.startsWith("/") ? path : `/${path}`}` : base;
};

const resolveUrl = (envValue, fallbackPort, path = "") => {
  if (isLocalEnvironment()) {
    return buildLocalUrl(fallbackPort, path);
  }
  return envValue || (typeof window !== "undefined" ? `${window.location.origin}${path}` : buildLocalUrl(fallbackPort, path));
};

const resolveApiBase = (path = "", fallbackPort = 8080) => {
  if (isLocalEnvironment()) {
    return buildLocalUrl(fallbackPort, path);
  }
  return process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? `${window.location.origin}${path}` : buildLocalUrl(fallbackPort, path));
};

const defaultConfig = {
  port: Number(process.env.REACT_APP_PORT || 3001),
  apiBase: resolveApiBase("/api/clinic/auth", 8080),
  dashboardUrl: resolveUrl(process.env.REACT_APP_APP_URL || process.env.REACT_APP_DASHBOARD_URL || process.env.REACT_APP_REAL_DASHBOARD_URL, 3002, "/admin-dashboard"),
};

export const appConfig = {
  port: runtimeConfig.port || process.env.REACT_APP_PORT || defaultConfig.port,
  apiBase: runtimeConfig.apiBase || process.env.REACT_APP_API_BASE || defaultConfig.apiBase,
  dashboardUrl: runtimeConfig.dashboardUrl || process.env.REACT_APP_APP_URL || process.env.REACT_APP_DASHBOARD_URL || process.env.REACT_APP_REAL_DASHBOARD_URL || defaultConfig.dashboardUrl,
};

export default appConfig;
